import { getRatingDetails, isRated } from '@kissui/helpers/src/rating.service'

export const renderRatings = ({ sku, minimum_rating = 0 }, component) => {
    getRatingDetails(sku)
        .then(ratings => {
            const ratingElementBlock = component.querySelector('.cb-ratings-block')
            if (!ratings || !isRated(ratings, minimum_rating)) {
                if (ratingElementBlock) {
                    ratingElementBlock.innerHTML = ''
                }

                return ''
            }

            if (ratingElementBlock) {
                ratingElementBlock.innerHTML = `<nb-rating stars="${ratings.ratingAverage}"></nb-rating>`
            }
        })
        .catch(err => {
            const ratingElementBlock = component.querySelector('.cb-ratings-block')
            if (ratingElementBlock) {
                ratingElementBlock.innerHTML = ''
            }
            console.error(err)
        })

    return ''
}

export const renderRatingsWithData = props => {
    const {
        show_ratings,
        minimum_rating = 0,
        ratingAverage,
        reviewCount,
        review_cta,
        reviews_cta
    } = props

    if (!show_ratings || !isRated(props, minimum_rating)) {
        return ''
    }

    let link = ''
    if (reviewCount && review_cta && reviews_cta) {
        const ctaLabel = (reviewCount > 1 ? reviews_cta : review_cta).replace(
            '{nb_review}',
            reviewCount
        )
        if (ctaLabel) {
            link = `<nb-link class="is-review" icon_right="chevron-right" size="small" color="gold">
                        ${ctaLabel}
                    </nb-link>`
        }
    }

    const toInt = parseFloat(ratingAverage).toFixed(2)

    return `<nb-rating stars="${toInt}"></nb-rating>
            ${link}`
}
